const _unique = definitions => {
  const names = {};
  return definitions.filter(definition => {
    if (definition.kind !== 'FragmentDefinition') {
      return true;
    }
    const name = definition.name.value;
    if (names[name]) {
      return false;
    } else {
      names[name] = true;
      return true;
    }
  });
};
// Do not import this file, graphql-tag, or hubspot-apollo-client outside of this folder,
// as this would cause a missing dependency issue for most consumers. Only consumers that
// use graphql are expected to have these dependencies and will intentionally import these
// fragments.

import { gql } from '@apollo/client';
import { PropertyDefinitionKeyFields } from 'hubspot-apollo-client/fragments';
export const PropertyInputUpdateCrmObjectPropertiesPayloadErrorFields = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyInputUpdateCrmObjectPropertiesPayloadErrorFields\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"UpdateCrmObjectPropertiesPayload\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"userErrorsExpanded\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"code\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"message\"}},{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"UniquePropertyValueConflictMutationError\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"propertyName\"}}]}}]}}]}}]}", {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "PropertyInputUpdateCrmObjectPropertiesPayloadErrorFields"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "UpdateCrmObjectPropertiesPayload"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "userErrorsExpanded"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "code"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "message"
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "UniquePropertyValueConflictMutationError"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "propertyName"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
});
/**
 * We provide this fragment to give consumers a shared point of access for
 * property definition queries. This fragment should be kept in sync with the available fields
 * on the PropertyDefinition GQL schema so that the returned data can be safely used in
 * property inputs and formatters.
 */
export const PropertyInputPropertyDefinitionFields = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyInputPropertyDefinitionFields\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyDefinition\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyDefinitionKeyFields\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"calculated\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"calculation\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"calculationFormula\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"canArchive\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"canRestore\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currencyPropertyName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"customizedDefault\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"dataSensitivity\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"definitionSource\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"deleted\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"description\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayMode\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayOrder\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"enforceMultivalueUniqueness\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"externalOptions\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"externalOptionsMetadata\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"filteringMetaData\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"pipelineIds\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"relatedObjectTypeId\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"externalOptionsReferenceType\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"fieldType\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"formField\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"fulcrumTimestamp\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"groupName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hasUniqueValue\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hidden\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hubspotDefined\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"janusGroup\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"label\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"multiValued\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"mutableDefinitionNotDeletable\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"numberDisplayHint\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"optionSortStrategy\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"options\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"description\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayOrder\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"doubleData\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hidden\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"label\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"readOnly\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"optionsAreMutable\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"permission\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"accessLevel\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"propertyRequirements\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"gates\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"scopeNames\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"settings\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"readOnlyDefinition\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"readOnlyValue\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"referencedObjectType\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"rollup\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"searchTextAnalysisMode\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"searchableInGlobalSearch\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"sensitive\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"sensitiveDataCategories\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"showCurrencySymbol\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"syncProperty\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"textDisplayHint\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"userFriendlyFqn\"}}]}}]}", {
  kind: "Document",
  definitions: _unique([{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "PropertyInputPropertyDefinitionFields"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "PropertyDefinition"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "FragmentSpread",
        name: {
          kind: "Name",
          value: "PropertyDefinitionKeyFields"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "calculated"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "calculation"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "calculationFormula"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "canArchive"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "canRestore"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "currencyPropertyName"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "customizedDefault"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "dataSensitivity"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "definitionSource"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "type"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "deleted"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "description"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "displayMode"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "displayOrder"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "enforceMultivalueUniqueness"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "externalOptions"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "externalOptionsMetadata"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "filteringMetaData"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "pipelineIds"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "relatedObjectTypeId"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "externalOptionsReferenceType"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "fieldType"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "formField"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "fulcrumTimestamp"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "groupName"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "hasUniqueValue"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "hidden"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "hubspotDefined"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "janusGroup"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "label"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "multiValued"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "mutableDefinitionNotDeletable"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "numberDisplayHint"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "objectTypeId"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "optionSortStrategy"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "options"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "description"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "displayOrder"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "doubleData"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "hidden"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "readOnly"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "value"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "optionsAreMutable"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "permission"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "accessLevel"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "propertyRequirements"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "gates"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "scopeNames"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "settings"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "readOnlyDefinition"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "readOnlyValue"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "referencedObjectType"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "rollup"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "searchTextAnalysisMode"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "searchableInGlobalSearch"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "sensitive"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "sensitiveDataCategories"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "showCurrencySymbol"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "syncProperty"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "textDisplayHint"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "type"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "userFriendlyFqn"
        }
      }]
    }
  }].concat(PropertyDefinitionKeyFields.definitions))
});
export const PropertyInputPropertyValueFields = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyInputPropertyValueFields\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyValue\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"source\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"sourceId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"timestamp\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"permission\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"accessLevel\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"definition\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyInputPropertyDefinitionFields\"}}]}}]}}]}", {
  kind: "Document",
  definitions: _unique([{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "PropertyInputPropertyValueFields"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "PropertyValue"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "value"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "source"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "sourceId"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "timestamp"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "permission"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "accessLevel"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "definition"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "PropertyInputPropertyDefinitionFields"
            }
          }]
        }
      }]
    }
  }].concat(PropertyInputPropertyDefinitionFields.definitions))
});